import React, { useEffect } from "react";
import { pdf } from "@react-pdf/renderer";
import { dismissToast, showToast } from "../Forms/Dialogs/Toast/Toast";
import { ToastProps } from "../CustomizedDashboard/DashboardTypes";
import { showErrorDialog } from "@SeemplicityDev/shared";

export const DOWNLOADING_PDF_TOAST_ID = "downloading-pdf-toast-id";

interface UseExportPDFOptions {
  shouldDownload: boolean;
  pdfComponent: React.ReactElement;
  getDataUrls: () => Promise<string[]>;
  filename: string;
  toastMessage: React.ReactNode;
  onDownloadFinished?: () => void;
}

const useExportPDF = ({
  shouldDownload,
  pdfComponent,
  getDataUrls,
  filename,
  toastMessage,
  onDownloadFinished,
}: UseExportPDFOptions) => {
  const exportPDF = async () => {
    const dataUrls = await getDataUrls();
    const blob = await pdf(
      React.cloneElement(pdfComponent, { imageDataUrls: dataUrls })
    ).toBlob();

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };

  useEffect(() => {
    if (shouldDownload) {
      exportPDF()
        .then(() => {
          onDownloadFinished?.();
          setTimeout(() => {
            const typedShowToast = showToast as (props: ToastProps) => string;
            typedShowToast({
              position: "top-center",
              hideProgressBar: false,
              autoClose: "3000",
              draggable: false,
              message: <div className="modal-text">{toastMessage}</div>,
            });
          }, 500);
        })
        .catch((err) => {
          showErrorDialog({ message: err.message });
        })
        .finally(() => {
          onDownloadFinished?.();
          const toastToDismiss = JSON.parse(
            localStorage.getItem(DOWNLOADING_PDF_TOAST_ID) || "null"
          );
          if (toastToDismiss) {
            dismissToast(toastToDismiss);
          }
        });
    }
  }, [shouldDownload]);
};

export default useExportPDF;
